'use client'

import { useTranslations } from 'next-intl'
import { ClockIcon } from '@/_assets/icon-components'
import { IWorkHour } from '@/_types'
import BottomSheet from '@/_components/Sheet'
import DetailButton from '@/_components/DetailButton'
import OffHoursModal from './OffHoursModal'
import { useSelector } from 'react-redux'
import { IRedux } from '@/_store/types'
import { Form } from './form'
import { useDisclosure } from '@chakra-ui/react'

interface IProps {
  scheduleData?: { working_hours: IWorkHour[] }
  formattedTime: string
  interval: number
  showTrigger?: boolean
  onConfirm: (time: string) => void
  open?: boolean
  onOpen?: () => void
  onClose?: () => void
}

export default function TimeMobile({
  formattedTime,
  interval = 0,
  scheduleData,
  onConfirm,
  showTrigger = true,
  open: controlledOpen,
  onOpen: controlledOnOpen,
  onClose: controlledOnClose,
}: IProps) {
  const t = useTranslations()
  const { order_type } = useSelector((state: IRedux) => state.session)
  const disclosure = useDisclosure()
  const open = controlledOpen ?? disclosure.open
  const onOpen = controlledOnOpen ?? disclosure.onOpen
  const onClose = controlledOnClose ?? disclosure.onClose

  const timeLabel =
    order_type?.type === 'self-pickup' ? t('pickup_time') : t('delivery_time')

  return (
    <>
      {showTrigger && (
        <>
          <DetailButton
            value={formattedTime}
            label={timeLabel}
            leftIcon={<ClockIcon color='#676767' />}
            onClick={onOpen}
          />
          <OffHoursModal onPreorder={onOpen} />
        </>
      )}

      <BottomSheet isOpen={open} contentHeight='content' onClose={onClose}>
        <Form
          interval={interval}
          scheduleData={scheduleData}
          onConfirm={(val) => {
            onConfirm(val)
            onClose?.()
          }}
        />
      </BottomSheet>
    </>
  )
}
